function parseNextDeliveryDate() {
  if (typeof luxon === 'undefined') {
    setTimeout(function() {
      parseNextDeliveryDate();
    }, 100);
  }
  
  var today = new Date();
  var newDay = new Date();
  var day = today.getDay();
  
  var matchedHoliday = false;
  for (var i = 0; i < window.Theme.holidays.length; i++) {
    var holiday = window.Theme.holidays[i];
    var startDate = new Date(holiday.order_cutoff);
    var endDate = new Date(holiday.order_resume);
    var nextDeliveryDate = new Date(holiday.next_delivery_pickup_date);
  
    if (today >= startDate && today < endDate) {
      newDay = nextDeliveryDate;
      matchedHoliday = true;
      break;
    }
  }
  
  if (!matchedHoliday) {
    if (day === 0) { // Sunday
      newDay.setDate(newDay.getDate() + 5); 
    } else if (day === 1) { // Monday
      newDay.setDate(newDay.getDate() + 4); 
    } else if (day === 2) { // Tuesday
      newDay.setDate(newDay.getDate() + 3); 
    } else if (day === 3) { // Wednesday
      newDay.setDate(newDay.getDate() + 2); 
    } else if (day === 4) { // Thursday
      if (today.getHours() < 12) {
        newDay.setDate(newDay.getDate() + 1);
      } else {
        newDay.setDate(newDay.getDate() + 8);
      }
    } else if (day === 5) { // Friday
      newDay.setDate(newDay.getDate() + 7); 
    } else if (day === 6) { // Saturday
      newDay.setDate(newDay.getDate() + 6); 
    }
  }
  
  const parsedDate = luxon.DateTime.fromJSDate(newDay);
  
  document.querySelector('.delivery-message').innerHTML = 'Next Delivery Date is:<br />' + parsedDate.toLocaleString(luxon.DateTime.DATE_HUGE);
}

parseNextDeliveryDate();
